import Directory from "Components/Directory/Directory";

// Azul del handoff (`$handoff-blue` en styles/variables.scss). **No** es el $primary
// del tema (#409eff): son dos azules distintos y el recuadro de DrApp va con el del
// handoff. El componente se usa sólo en el menú de cuenta, así que la constante alcanza
// para acotar el cambio a esa pantalla.
export const DRAPP_COLOR = "#13629b";

// Recuadro de la cartilla de DrApp. Mismo comportamiento que Components/Crontu — sólo
// cambian el logo y el color. El resto de las props pasa tal cual a Directory.
// Los recuadros de DrApp van sin borde y con relleno blanco: en el menú de cuenta se
// recortan contra el gris de la sección, y la separación la da el border-top, no un marco.
const DrApp = ({ link, ...props }) => (
  <Directory
    logo="/favicon.png"
    alt="DrApp"
    color={DRAPP_COLOR}
    border={false}
    background="#ffffff"
    url={link}
    {...props}
  />
);

export default DrApp;
